export interface NewsSection {
  text?: string;
  image?: string;
}

export interface NewsItem {
  id: string;
  title: string;
  date: string;
  author: string;
  type: "新闻" | "作品介绍" | "行业动态";
  cover: string;
  excerpt: string;
  content: NewsSection[];
}

export const newsTypes: Array<NewsItem["type"]> = ["新闻", "作品介绍", "行业动态"];

export const news: NewsItem[] = [
  {
    id: "n01",
    title: "《妖精的森林物语》单行本第 12 卷正式发售，收录全新番外篇",
    date: "2026-10-12",
    author: "编辑部 · 林夕",
    type: "新闻",
    cover: "https://readdy.ai/api/search-image?query=Warm%20editorial%20photograph%20of%20an%20open%20stack%20of%20fantasy%20manga%20volumes%20on%20a%20wooden%20desk%20with%20a%20cup%20of%20tea%20and%20dried%20flowers%2C%20soft%20natural%20daylight%2C%20violet%20and%20cream%20tones%2C%20cozy%20literary%20atmosphere%2C%20high%20detail&width=1200&height=675&seq=news-cover-01&orientation=landscape",
    excerpt: "人气治愈系作品《妖精的森林物语》单行本第 12 卷今日发售，随书附赠限定签绘卡与从未公开的番外篇。",
    content: [
      { text: "由森野绘创作、连载三年的人气作品《妖精的森林物语》，今日正式推出单行本第 12 卷。本卷收录了「春之回响」篇的完整内容，并首次公开了树灵视角的番外短篇。" },
      { text: "出版社方面表示，本次首刷特别附赠限定签绘卡一张，以及还原森林场景的折页海报。作者森野绘在寄语中提到，这一卷是她个人最喜欢的一卷，因为「莉芙终于在这里，第一次主动拥抱了别人」。" },
      { image: "https://readdy.ai/api/search-image?query=Close%20up%20editorial%20shot%20of%20a%20fantasy%20manga%20volume%20cover%20held%20in%20hands%20with%20blurred%20sunlit%20bookshelf%20behind%2C%20warm%20neutral%20tones%2C%20soft%20depth%20of%20field%2C%20inviting%20reading%20mood&width=1200&height=675&seq=news-body-01&orientation=landscape" },
      { text: "此外，官方宣布第 13 卷将于明年春季推出，剧情将进入「古老树林」最终章。届时也会有特别纪念活动，详情请关注官方后续公告。" },
    ],
  },
  {
    id: "n02",
    title: "专题：为什么妖精题材总能打动人心？五位作者谈创作初心",
    date: "2026-10-11",
    author: "特约撰稿 · 苏晴",
    type: "行业动态",
    cover: "https://readdy.ai/api/search-image?query=Artistic%20overhead%20flat%20lay%20of%20manga%20sketchbooks%20and%20pencils%20on%20a%20desk%20with%20warm%20ambient%20light%2C%20soft%20violet%20and%20amber%20tones%2C%20creative%20studio%20atmosphere%2C%20editorial%20photography%20style%2C%20detailed%20textures&width=1200&height=675&seq=news-cover-02&orientation=landscape",
    excerpt: "妖精、精灵与妖怪，为何经久不衰？我们邀请了五位活跃在妖精题材一线的创作者，聊聊他们笔下的奇幻世界。",
    content: [
      { text: "从北欧神话到东方志怪，妖精形象总是介于人与自然之间。它们既非纯粹的人类，也并非完全的异类，这种「中间性」或许正是妖精题材长盛不衰的原因。" },
      { text: "森野绘认为，妖精是「森林的语言」；狐月则偏爱妖怪身上「带着遗憾却依然温柔」的部分；而白露说，她写月光精灵，其实是在写那些「明明想靠近却又害怕受伤」的人。" },
      { image: "https://readdy.ai/api/search-image?query=Creative%20interview%20scene%20with%20sketchbook%20and%20color%20pencils%20scattered%20on%20a%20wooden%20table%20beside%20a%20steaming%20tea%20cup%2C%20warm%20golden%20hour%20light%2C%20cozy%20artistic%20mood%2C%20shallow%20depth%20of%20field&width=1200&height=675&seq=news-body-02&orientation=landscape" },
      { text: "本期专题整理了五位作者的对谈精华，也附上了他们各自的推荐书单，欢迎在资讯区继续探索。" },
    ],
  },
  {
    id: "n03",
    title: "《妖怪茶馆夜话》动画化确定，先导视觉图公开",
    date: "2026-10-10",
    author: "编辑部 · 阿澈",
    type: "新闻",
    cover: "https://readdy.ai/api/search-image?query=Atmospheric%20night%20scene%20of%20a%20traditional%20Japanese%20tea%20house%20lit%20by%20warm%20paper%20lanterns%20in%20a%20misty%20alley%2C%20deep%20amber%20glow%20against%20dark%20blue%20night%2C%20cinematic%20anime%20key%20visual%20style%2C%20moody%20detailed%20illustration&width=1200&height=675&seq=news-cover-03&orientation=landscape",
    excerpt: "狐月老师笔下的《妖怪茶馆夜话》正式宣布动画化，官方同步放出了以狐妖掌柜为主角的先导视觉图。",
    content: [
      { text: "备受好评的单元剧漫画《妖怪茶馆夜话》今日宣布动画化，由知名制作公司操刀，预计于 2027 年夏季播出。" },
      { text: "此次率先公开的先导视觉图中，狐妖掌柜站在子夜灯下的茶馆门前，手持一盏未点亮的纸灯，画面温暖而神秘，忠实还原了原作的和风质感。" },
      { image: "https://readdy.ai/api/search-image?query=Elegant%20anime%20key%20visual%20of%20a%20fox%20spirit%20character%20silhouette%20against%20glowing%20lanterns%2C%20warm%20orange%20and%20deep%20indigo%20gradient%2C%20cinematic%20fantasy%20illustration%2C%20highly%20detailed%20atmospheric%20mood&width=1200&height=675&seq=news-body-03&orientation=landscape" },
      { text: "作者狐月表示，看到笔下的茶馆「真的亮起灯来」，激动得一夜没睡。更多制作阵容信息将在后续陆续公开。" },
    ],
  },
  {
    id: "n04",
    title: "新作介绍：《冰晶精灵的苏醒》——一场南国与冰雪的相遇",
    date: "2026-10-08",
    author: "编辑部 · 星野",
    type: "作品介绍",
    cover: "https://readdy.ai/api/search-image?query=Ethereal%20fantasy%20scene%20of%20a%20translucent%20frozen%20giant%20flower%20glowing%20in%20a%20snowy%20landscape%20under%20aurora%20light%2C%20icy%20blue%20and%20violet%20palette%2C%20cinematic%20detailed%20illustration%2C%20magical%20cold%20shimmer&width=1200&height=675&seq=news-cover-04&orientation=landscape",
    excerpt: "一个怕冷的南方少年，一位沉睡千年的冰晶精灵。雪见遥的新作，用轻松搞笑的笔触讲述了最温柔的相遇。",
    content: [
      { text: "在妖精题材越来越卷写「宏大史诗」的当下，雪见遥选择了另一条路——用日常喜剧的节奏，讲一个关于「被误解」的温柔故事。" },
      { text: "主角是南国出生、怕冷到极点的魔法师学徒；女主角则是沉睡千年的冰晶精灵。两人从宿敌到同伴的转变，既有笑点也有泪点。" },
      { image: "https://readdy.ai/api/search-image?query=Two%20small%20manga%20characters%20one%20shivering%20in%20a%20coat%20and%20one%20glowing%20ice%20spirit%20in%20a%20snowy%20mountain%20scene%2C%20playful%20lighthearted%20illustration%2C%20cool%20blue%20and%20warm%20accent%20palette%2C%20detailed%20fantasy%20art&width=1200&height=675&seq=news-body-04&orientation=landscape" },
      { text: "本作目前已更新至第 41 话，正处于人气上升期，喜欢轻松奇幻日常的读者不妨一读。" },
    ],
  },
  {
    id: "n05",
    title: "妖精漫画读者票选年度人气作品结果公布",
    date: "2026-10-06",
    author: "编辑部 · 林夕",
    type: "新闻",
    cover: "https://readdy.ai/api/search-image?query=Festive%20editorial%20scene%20of%20colorful%20manga%20volumes%20arranged%20on%20a%20light%20wooden%20display%20with%20small%20ribbon%20decorations%2C%20soft%20natural%20light%2C%20bright%20cheerful%20warm%20tones%2C%20high%20detail%20photography%20style&width=1200&height=675&seq=news-cover-05&orientation=landscape",
    excerpt: "经过为期两周的投票，年度人气妖精漫画票选结果正式揭晓，前三名分别是《妖怪茶馆夜话》《妖精的森林物语》与《风之妖精的恋歌》。",
    content: [
      { text: "本次票选共收到超过十二万张有效选票，参与作品多达近百部，竞争异常激烈。" },
      { text: "最终，《妖怪茶馆夜话》以微弱优势夺冠，作者狐月在感谢视频中笑称「是掌柜的茶太香了」。第二名《妖精的森林物语》与第三名《风之妖精的恋歌》同样收获了极高人气。" },
      { image: "https://readdy.ai/api/search-image?query=Stack%20of%20popular%20fantasy%20manga%20volumes%20with%20a%20golden%20ribbon%20badge%20on%20top%2C%20warm%20bright%20studio%20lighting%2C%20clean%20neutral%20background%2C%20celebratory%20editorial%20photo%20style%2C%20sharp%20detail&width=1200&height=675&seq=news-body-05&orientation=landscape" },
      { text: "主办方表示，来年将增设「最佳新作」与「人气角色」两个新奖项，敬请期待。" },
    ],
  },
  {
    id: "n06",
    title: "产业观察：妖精题材如何从「小众」走向「破圈」",
    date: "2026-10-04",
    author: "行业观察 · 陈屿",
    type: "行业动态",
    cover: "https://readdy.ai/api/search-image?query=Modern%20editorial%20desk%20scene%20with%20charts%20and%20a%20tablet%20showing%20colorful%20illustrations%2C%20soft%20violet%20and%20mint%20accent%20tones%2C%20clean%20professional%20atmosphere%2C%20natural%20window%20light%2C%20detailed%20realistic%20photography&width=1200&height=675&seq=news-cover-06&orientation=landscape",
    excerpt: "过去几年，妖精题材从小众爱好逐渐进入主流视野。这背后，是创作方式、传播渠道与读者结构共同变化的结果。",
    content: [
      { text: "十年前，妖精题材还常常被视为「小众中的小众」。而如今，头部妖精漫画的动画化、周边化已经屡见不鲜。" },
      { text: "越来越多的女性作者与年轻创作者加入，让妖精题材在叙事上更加多元；而社交平台的传播，也让优质作品更容易被「刷到」。" },
      { image: "https://readdy.ai/api/search-image?query=Soft%20abstract%20editorial%20visual%20of%20growth%20charts%20and%20bright%20color%20swatches%20on%20a%20clean%20desk%2C%20mint%20green%20and%20violet%20accents%2C%20modern%20minimal%20design%2C%20soft%20natural%20lighting&width=1200&height=675&seq=news-body-06&orientation=landscape" },
      { text: "当然，破圈也带来了同质化隐忧。如何在热度中保持创作的真诚，仍是每位创作者需要回答的问题。" },
    ],
  },
  {
    id: "n07",
    title: "《龙鳞魔法学院》主线剧情迎来重大转折，第 130 话引热议",
    date: "2026-10-11",
    author: "编辑部 · 阿澈",
    type: "新闻",
    cover: "https://readdy.ai/api/search-image?query=Grand%20fantasy%20academy%20library%20scene%20with%20towering%20bookshelves%20and%20floating%20magical%20books%2C%20warm%20candle%20light%20mixed%20with%20cool%20blue%20magic%20glow%2C%20cinematic%20detailed%20illustration%2C%20epic%20mood&width=1200&height=675&seq=news-cover-07&orientation=landscape",
    excerpt: "《龙鳞魔法学院》最新一话揭晓了主角身世的关键线索，读者讨论区一夜之间被「原来如此」刷屏。",
    content: [
      { text: "连载已逾百话的《龙鳞魔法学院》，在第 130 话投下了一枚重磅炸弹——主角所持的那片龙鳞，竟来自学院创立者本人。" },
      { text: "这一话发布后，读者讨论区迅速被讨论贴淹没，不少长期读者表示「前面埋的伏笔全都串起来了」。作者星野凛则回应称，这才是「真正的序章」。" },
      { image: "https://readdy.ai/api/search-image?query=Dramatic%20close%20up%20of%20a%20glowing%20dragon%20scale%20held%20in%20a%20young%20mage%20hand%2C%20blue%20and%20gold%20magic%20particles%2C%20detailed%20fantasy%20illustration%2C%20intense%20cinematic%20lighting&width=1200&height=675&seq=news-body-07&orientation=landscape" },
      { text: "本作目前仍在连载中，节奏迎来提速，值得追更。" },
    ],
  },
  {
    id: "n08",
    title: "新作介绍：《露珠与月桂冠》完结纪念，作者谈结局设计",
    date: "2026-09-28",
    author: "特约撰稿 · 苏晴",
    type: "作品介绍",
    cover: "https://readdy.ai/api/search-image?query=Serene%20moonlit%20garden%20scene%20with%20a%20laurel%20wreath%20resting%20on%20soft%20petals%20and%20glistening%20dewdrops%2C%20silver%20lavender%20and%20pearl%20palette%2C%20delicate%20painterly%20illustration%2C%20peaceful%20elegant%20mood&width=1200&height=675&seq=news-cover-08&orientation=landscape",
    excerpt: "刚刚完结的《露珠与月桂冠》以一场温柔的道别收尾。作者白露首次公开了这个结局背后的思考。",
    content: [
      { text: "《露珠与月桂冠》在上月迎来完结，48 话的篇幅讲述了一位无法流泪的妖精公主，如何学会告别。" },
      { text: "作者白露坦言，这个结局她改了三稿。「我一开始想给她一个永远在一起的结果，但后来发现，学会说再见，才是她真正需要的成长。」" },
      { image: "https://readdy.ai/api/search-image?query=Gentle%20illustration%20of%20two%20silhouetted%20figures%20parting%20in%20a%20moonlit%20flower%20garden%2C%20soft%20silver%20and%20lavender%20tones%2C%20emotional%20delicate%20painterly%20style%2C%20dreamy%20atmosphere&width=1200&height=675&seq=news-body-08&orientation=landscape" },
      { text: "虽然作品已完结，但白露透露下一部作品已在筹备中，题材仍会围绕妖精，但会尝试更明快的风格。" },
    ],
  },
  {
    id: "n09",
    title: "妖精漫画线下主题展将于下月开幕，现场还原森林场景",
    date: "2026-09-25",
    author: "编辑部 · 星野",
    type: "新闻",
    cover: "https://readdy.ai/api/search-image?query=Immersive%20exhibition%20space%20with%20glowing%20forest%20installation%20and%20suspended%20paper%20leaves%2C%20soft%20violet%20and%20emerald%20ambient%20lighting%2C%20modern%20museum%20atmosphere%2C%20cinematic%20detailed%20photography&width=1200&height=675&seq=news-cover-09&orientation=landscape",
    excerpt: "由妖精漫画联合多家出版社举办的线下主题展，将于下月在市中心美术馆开幕，现场将还原多个经典漫画场景。",
    content: [
      { text: "本次线下主题展以「走入妖精的森林」为主题，将 1:1 还原《妖精的森林物语》中的古老树林与《妖怪茶馆夜话》的子夜茶馆。" },
      { text: "主办方介绍，展区设置了互动光影装置，观众走入其中，脚下的落叶会随着脚步亮起微光，仿佛真的踏入了漫画世界。" },
      { image: "https://readdy.ai/api/search-image?query=Visitors%20walking%20through%20an%20immersive%20glowing%20forest%20installation%20with%20projected%20leaves%2C%20enchanting%20violet%20and%20green%20light%2C%20modern%20art%20exhibition%20photography%2C%20detailed%20atmospheric%20scene&width=1200&height=675&seq=news-body-09&orientation=landscape" },
      { text: "展览将持续一个月，现场还设有官方周边贩售区与作者签售活动，喜欢妖精题材的朋友不要错过。" },
    ],
  },
];